import { Selector } from '@ngxs/store';
import { UiState } from '@store/states/ui.state';
import { UiStateModel } from '@store/models/ui.model';

export class UiSelectors {
  @Selector([UiState])
  static sideBarOpen(state: UiStateModel) {
    return state.sideBarOpen;
  }

  @Selector([UiState])
  static infoOnScreenOpen(state: UiStateModel) {
    return state.infoOnScreenOpen;
  }

  @Selector([UiState])
  static appInfoOpen(state: UiStateModel) {
    return state.appInfoOpen;
  }

  @Selector([UiState])
  static startcodesMasked(state: UiStateModel) {
    return state.startcodesMasked;
  }

  @Selector([UiState])
  static forbidden403Access(state: UiStateModel) {
    return state.forbidden403Access;
  }
}
